import { Door, Entity, FrenchDoor, Functionality, Joinery, SceneConstants, TechnicalElement, Window } from "@rhinov/savane-js";
import { CocosServices } from "../services";
import { _ASSET_TYPE, getAssets } from "@rhinov/asset-manager-service";



export class TulipAssetConstant {

    functionalities: Functionality[] = [];
    model: any;
    dropDownDatas: any;
    // Joinery models, all joineries in first one and specific joineries in the others
    allJoineryModels: any = [];
    allDoorsModels: any = [];
    allDoorsDoubleModels: any = [];
    allDoorsFrontModels: any = [];
    allCupboardDoorModels: any = [];
    allGarageDoorModels: any = [];
    allWindowModels: any = [];
    allWindowDoubleModels: any = [];
    allFrenchWindowModels: any = [];
    allFrenchWindowDoubleModels: any = [];
    allPictureWindowModels: any = [];
    allFixedWindowModels: any = [];
    allNicheWindowModels: any = [];
    allVeluxModels: any = [];
    allCanopyModels: any = [];
    allOpeningModels: any = [];

    // Technical elements, all technical elements in the first one and specific technical elements in the others
    allTechElementsModels: any = [];
    allModelsForCurrentTechnicalElement: any = [];
    allPoleModels: any = [];
    allStoveModels: any = [];
    allFireplaceModels: any = [];
    allRadiatorModels: any = [];
    allBoilerModels: any = [];
    allSwitchBoardModels: any = [];
    allAirConditionerModels: any = [];
    allWardRobeModels: any = [];
    allSpotLightModels: any = [];
    allRosetteModels: any = [];
    allBeamModels: any = [];
    allStairModels: any = [];
    allCircularStairModels: any = [];
    allWallDecorationModels: any = [];
    allSocketModels: any = [];

    // All models for decorated walls (only one for those ones for the moment, not split in several sub types yet)
    allModelsForCurrentDecoratedWall: any = [];

    // All models for cornice (only one for those ones for the moment, not split in several sub types yet)
    allModelsForCurrentCornice: any = [];

    // All project for smart design of the current room
    allProjectsForSmartDesign: any = [];

    // Optimization to get only the fields we want from the DB
    OPTIMIZED_DB_FIELDS: string = '&sort=created_at&fields=_id,manufacturer,retailer,joineryType,technicalElementType,decoratedWallType,pipeline.servicesStatus,pipeline.state,pipeline.servicesNeeded,pipeline.modelState,dimensions,name,isScalable,joineryColor,canopyNbPanel';


    constructor () {
        const g = globalThis as any;
        if (g.__rhinov_TulipAssetConstant_instance) return g.__rhinov_TulipAssetConstant_instance;
        this.functionalities = [];
        CocosServices.getSortedFunctionalities((response: any) => {
            this.functionalities = response.data;
        });

        this.model =       
            {
                intensity: 0,
                materialType: 0,
                closureType: 0,
                limonType: 0,
                _colorId: 0,
                renderType: 1,
                format: 0,
                cameraType: 0,
                quality: 2,
                lightType: 0,
                weather: 1,
                exterior: 'None',
                additionalExterior: 'None',
                kitchenShape: 0,
                mealZone: 0
            };

        this.dropDownDatas = {
            plinthsMaterialList: [
                { name: 'Blanc', value: 0 },
                { name: 'Comme sol', value: 1 },
                { name: 'Comme mur', value: 2 }
            ],
            cornicesMaterialList: [
                { name: 'Blanc', value: 0 },
                { name: 'Comme plafond', value: 1 },
                { name: 'Comme mur', value: 2 }
            ],
            spotLightIntensityList: [
                { name: 'Faible', value: SceneConstants.SpotLightIntensity.lowPower },
                { name: 'Moyenne', value: SceneConstants.SpotLightIntensity.mediumPower },
                { name: 'Forte', value: SceneConstants.SpotLightIntensity.highPower }
            ],
            lightTemperatureList: [
                { name: 'Normal', value: SceneConstants.LightTemperature.normal },
                { name: 'Chaud', value: SceneConstants.LightTemperature.warm },
                { name: 'Froid', value: SceneConstants.LightTemperature.cold },
                { name: 'Couleur personalisée', value: SceneConstants.LightTemperature.color }
            ],
            kitchenDoorTypeList: [
                { name: 'Cuisinella lisse', value: Functionality.KitchenDoorType.lisse },
                { name: 'Cuisinella cadre', value: Functionality.KitchenDoorType.cadre },
                { name: 'Cuisinella gorge', value: Functionality.KitchenDoorType.gorge },
                { name: 'Cuisinella rainure', value: Functionality.KitchenDoorType.rainure }
            ],
            deskTypeList: [
                { name: 'Indéterminé', value: Functionality.DeskType.undetermined },
                { name: 'Plateau avec pieds', value: Functionality.DeskType.withFeet },
                { name: 'Avec quelques rangements', value: Functionality.DeskType.withStorage },
                { name: 'Avec beaucoup rangements', value: Functionality.DeskType.withLotOfStorage }
            ],
            libraryTypeList: [
                { name: 'Indéterminé', value: Functionality.LibraryType.undetermined },
                { name: 'Totalement ouverte', value: Functionality.LibraryType.opened },
                { name: 'Partiellement ouverte', value: Functionality.LibraryType.semiOpened },
                { name: 'Entièrement fermée', value: Functionality.LibraryType.closed }
            ],
            bannedTableMaterialTypeList: [
                { name: 'Indéterminée', value: Functionality.TableBannedMaterialType.undetermined },
                { name: 'Bois', value: Functionality.TableBannedMaterialType.wood },
                { name: 'Verre', value: Functionality.TableBannedMaterialType.glass }
            ],
            sofaTypeList: [
                { name: 'Indéterminé', value: Functionality.SofaType.undetermined },
                { name: 'Convertible', value: Functionality.SofaType.convertible },
                { name: 'Méridienne', value: Functionality.SofaType.meridian },
                { name: 'Droit', value: Functionality.SofaType.straight }
            ],
            kitchenShapeList: [
                { name: 'Indéterminée', value: Functionality.KitchenShape.undetermined },
                { name: 'Forme en L', value: Functionality.KitchenShape.lshape },
                { name: 'Forme en U', value: Functionality.KitchenShape.ushape },
                { name: 'Ligne double', value: Functionality.KitchenShape.doubleline },
                { name: 'Ligne', value: Functionality.KitchenShape.line }
            ],
            mealZoneList: [
                { name: 'Indéterminée', value: Functionality.MealZone.undetermined },
                { name: 'Aucune', value: Functionality.MealZone.none },
                { name: 'Standard', value: Functionality.MealZone.meal },
                { name: 'Bar', value: Functionality.MealZone.bar }
            ],
            stairMaterialTypeList: [
                { name: 'Escalier 1', value: 0 },
                { name: 'Escalier 2', value: 1 },
                { name: 'Escalier 3', value: 2 },
                { name: 'Escalier 4', value: 3 },
                { name: 'Escalier 5', value: 4 },
                { name: 'Escalier 6', value: 5 },
                { name: 'Escalier 7', value: 6 },
                { name: 'Escalier 8', value: 7 },
                { name: 'Escalier 9', value: 8 },
                { name: 'Escalier 10', value: 9 },
                { name: 'Escalier 11', value: 10 },
                { name: 'Escalier 12', value: 11 },
                { name: 'Escalier 13', value: 12 },
                { name: 'Escalier 14', value: 13 },
                { name: 'Escalier 15', value: 14 }
            ],
            rampMaterialTypeList: [
                { name: 'Bois clair', value: 0 },
                { name: 'Bois foncé', value: 1 },
                { name: 'Blanc', value: 2 },
                { name: 'Noir', value: 3 },
                { name: 'Chrome', value: 4 },
                { name: 'Verre', value: 5 }
            ],
            joineryMaterialTypeList: [
                { name: 'PVC Blanc', value: 0 },
                { name: 'PVC Anthracite', value: 1 },
                { name: 'LA Métal Noir', value: 6 },
                { name: 'LA Bois Clair', value: 14 },
                { name: 'LA Bois Moyen', value: 15 },
                { name: 'LA Bois Ocre', value: 16 },
                { name: 'Bois Clair', value: 2 },
                { name: 'Bois Moyen', value: 5 },
                { name: 'Bois Foncé', value: 3 },
                { name: 'Gris Alu', value: 4 },
                { name: 'Sable', value: 7 },
                { name: 'Mineral', value: 8 },
                { name: 'Taupe', value: 9 },
                { name: 'Vert Clair (6021)', value: 10 },
                { name: 'Vert Moyen (7030)', value: 11 },
                { name: 'Bordeaux', value: 12 },
                { name: 'Bleu Cobalt (5013)', value: 13 }
            ],
            joineryCuisinellaSimpleCupboardMaterialTypeList: [
                { name: 'Rouge tibet', value: 1000 },
                { name: 'River blue', value: 1001 },
                { name: 'Metal', value: 1002 },
                { name: 'Curacao', value: 1003 },
                { name: 'Terre de Sienne', value: 1004 },
                { name: 'Pétale de rose', value: 1005 },
                { name: 'Misty blue', value: 1006 },
                { name: 'Kaki', value: 1007 },
                { name: 'Blanc', value: 1008 },
                { name: 'Havana oak', value: 1009 },
                { name: 'Dark oak 19', value: 1010 },
                { name: 'Chêne sable synchrone', value: 1011 },
                { name: 'Chêne atelier', value: 1012 },
                { name: 'Pannacotta majestic brillant', value: 1013 },
                { name: 'Osani oak', value: 1014 },
                { name: 'Nordic spirit', value: 1015 },
                { name: 'Darwin', value: 1016 },
                { name: 'Béton tisse 19', value: 1017 },
                { name: 'Yonga naturel', value: 1018 },
                { name: 'Soft grey', value: 1019 },
                { name: 'Quartz métal', value: 1020 },
                { name: 'Mistigris', value: 1021 },
                { name: 'Métal brossé', value: 1022 },
                { name: 'Grege majestic brillant', value: 1023 },
                { name: 'Blanc brillant 09', value: 1024 },
                { name: 'Winoka', value: 1025 },
                { name: 'Hipster wood', value: 1026 },
                { name: 'Dark fusion 19', value: 1027 },
                { name: 'Chêne timber', value: 1028 },
                { name: 'Chêne honey', value: 1029 },
                { name: 'Béton clair', value: 1030 },
                { name: 'Artic wood', value: 1031 },
                { name: 'Taupe mat', value: 1032 },
                { name: 'Pannacotta mat', value: 1033 },
                { name: 'Ombre soft', value: 1034 },
                { name: 'Blanc mat 14', value: 1035 },
                { name: 'Black', value: 1036 },
                { name: 'Miroir', value: 1037 }
            ],
            joineryCuisinellaDoubleCupboardMaterialTypeList: [
                { name: 'Noir et Nordic spirit', value: 2000 },
                { name: 'Blanc et Nordic spirit', value: 2001 },
                { name: 'Bleu misty et Nordic spirit', value: 2002 },
                { name: 'Taupe et Nordic spirit', value: 2003 },
                { name: 'Laqué métal et Nordic spirit', value: 2004 },
                { name: 'Noir et Chêne Honey', value: 2005 },
                { name: 'Blanc et Chêne Honey', value: 2006 },
                { name: 'Blanc et Pannacotta', value: 2007 }
            ],
            radiatorMaterialTypeList: [
                { name: 'Blanc', value: 0 },
                { name: 'Anthracite', value: 1 },
                { name: 'Noir', value: 2 },
                { name: 'Chrome', value: 3 },
                { name: 'Blanc mat', value: 4 },
                { name: 'Noir mat', value: 5 },
                { name: 'Bleu nuit', value: 6 },
                { name: 'Beige', value: 7 },
                { name: 'Vert d\'eau', value: 8 },
                { name: 'Blanc mat lumière', value: 9 },
                { name: 'Noir mat lumière', value: 10 }
            ],
            beamMaterialTypeList: [
                { name: 'Blanc', value: 7 },
                { name: 'Bois Peint Blanc', value: 3 },
                { name: 'Bois Clair', value: 2 },
                { name: 'Bois Moyen', value: 13 },
                { name: 'Bois Sombre', value: 1 },
                // Ajouté
                { name: 'Bois Très Foncé', value: 14},
                { name: 'Bois Usé Clair', value: 11 },
                // Ajouté
                { name: 'Bois Usé Moyen', value: 15},
                // Renommé
                { name: /*'Bois Usé Noeuds'*/'Bois Usé Foncé', value: 9 },
                { name: 'Bois Brosse Foncé', value: 12 },
                { name: 'Métal Noir', value: 5 }
                // Supprimé
                //{ name: 'Neutre', value: 0 },
                // Supprimé
                //{ name: 'Bois Usé', value: 4 },
                // Supprimé
                //{ name: 'Béton', value: 6 },
                // Supprimé
                //{ name: 'Bois Usé Terne', value: 8 },
                // Supprimé
                //{ name: 'Bois Usé Fissure', value: 10 },
            ],
            frameShapeTypeList: [
                { name: '1 poutre centrale', value: 0 },
                { name: '3 poutres centrales', value: 1 },
                { name: '5 poutres centrales', value: 2 },
                { name: 'Demie 3 poutres centrales', value: 3 }
            ],
            hoodShapeTypeList: [
                { name: 'Centrée/Centrée', value: 0 },
                { name: 'Centrée/Gauche', value: 1 },
                { name: 'Centrée/Droite', value: 2 },
                { name: 'Arrière/Centrée', value: 3 },
                { name: 'Arrière/Gauche', value: 4 },
                { name: 'Arrière/Droite', value: 5 }
            ],
            stairwayClosureList: [
                { name: 'Ouvert', value: 0 },
                { name: 'Ouvert + Contremarche', value: 1 },
                { name: 'Box', value: 2 },
                { name: 'Fermé', value: 3 }
            ],
            stairwayLimonList: [
                { name: 'Sans', value: 0 },
                { name: 'Central + oblique', value: 1 },
                { name: 'Central + carré', value: 2 },
                { name: 'Côté + oblique', value: 3 },
                { name: 'Côté + carré', value: 4 }
            ],
            formatList: [
                { name: 'Normal paysage', value: 0 },
                { name: 'Normal portrait', value: 1 },
                { name: 'Normal carré', value: 11 },
                { name: 'Rangement paysage', value: 13 },
                { name: 'Rangement portrait', value: 14 },
                // Unused
                //{ name: 'Instragram', value: 12 },
                // Unused
                //{ name: 'A4 paysage', value: 2 },
                // Unused
                //{ name: 'A4 portrait', value: 3 },
                // Unused
                //{ name: 'A3 paysage', value: 4 },
                // Unused
                //{ name: 'A3 portrait', value: 5 },
                // Unused
                //{ name: 'A0 paysage', value: 6 },
                // Unused
                //{ name: 'A0 portrait', value: 7 },
                { name: 'Content Factory', value: 15 },
                { name: 'Marketing 16:9', value: 16 },
                { name: 'Marketing Instagram', value: 17 },
                { name: 'Marketing Vertical', value: 18 },
                { name: 'Quizz - Carré', value: 9 },
                { name: 'Quizz - Paysage', value: 10 },      
                { name: 'Libre', value: 8 }
            ],
            renderTypeList: [
                { name: 'Inactif', value: 0 },
                { name: 'Jour', value: 1 },
                { name: 'Nuit', value: 2 },
                { name: 'Jour + Nuit', value: 3 }
            ],
            cameraTypeList: [
                { name: 'Perspective', value: 0 },
                { name: 'Panoramic', value: 1 },
                { name: 'Axonomic', value: 2 },
                { name: 'Rangement', value: 5 },
                { name: 'PhotoRender', value: 3 },
                { name: 'Video', value: 4 },
            ],
            cameraQualities: [
                { name: 'Uggly', value: '0' },
                { name: 'Preview', value: '1' },
                { name: 'Good', value: '2' },
                { name: 'Great', value: '3' },
                { name: 'Ultra', value: '4' }
            ],
            weatherTypeList: [
                { name: 'Ensoleillé', value: 0 },
                { name: 'Nuageux', value: 1 },
                { name: 'Couvert', value: 2 }
            ],
            exteriorTypeList: [
                { name: 'Aucun', value: 'None' },
                { name: 'Défaut/Client', value: 'defaut' },
                { name: 'Pavillon', value: 'pavillon' },
                { name: 'Ciel bleu', value: 'blue_sky' },
                { name: 'Ville (R+1)', value: 'ville' },
                { name: 'Jardin pavillon', value: 'tiergarten_16k_autumn copie' },
                { name: 'Forêt', value: 'Campagne_sol_jour' },
                { name: 'Mer Etage Jour', value: 'Mer_etage_jour' },
                { name: 'Montagnes', value: 'mountains' },
                //{ name: 'Pavillon', value: 'Vue_pavillon' },
                //{ name: 'Ville (R+3)', value: 'etage-ville' },
                //{ name: 'Mer Sol Jour', value: 'Mer_sol_jour' }
            ],
            boolean: [
                { name: 'Normal', value: 0 },
                { name: 'Union', value: 1 },
                { name: 'Soustraction', value: 2 },
                { name: 'Intersection', value: 3 }
            ]
        };

        // Load all decorated wall models info
        getAssets(_ASSET_TYPE.DECORATED_WALLS, this.OPTIMIZED_DB_FIELDS + '&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.medias.lk=vlp', (res: any) => {
            var resources = res.data.resources;

            if (resources !== undefined && resources !== null && resources.length > 0) {
                for (var i = 0; i < resources.length; i++) {
                    switch (resources[i].decoratedWallType.name) {
                        case 'Rambarde':
                            this.allModelsForCurrentDecoratedWall.push(resources[i]);
                            break;

                        case 'Cornice':
                            this.allModelsForCurrentCornice.push(resources[i]);
                            break;
                    }
                }
            }
        });

        // Load all joinery model info
        getAssets(_ASSET_TYPE.JOINERIES, this.OPTIMIZED_DB_FIELDS + '&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.medias.lk=vlp', (res: any) => {
            var resources = res.data.resources;

            if (resources !== undefined && resources !== null && resources.length > 0) {
                this.allJoineryModels = resources;

                for (var i = 0; i < resources.length; i++) {
                    var pushFront = false;
                    if (resources[i].manufacturer) {
                        pushFront = resources[i].manufacturer.priority !== 'generic';
                    }
                    switch (resources[i].joineryType.name) {
                        case 'Door':
                            if (pushFront) {
                                this.allDoorsModels.unshift(resources[i]);
                            } else {
                                this.allDoorsModels.push(resources[i]);
                            }
                            break;

                        case 'Door_Double':
                            if (pushFront) {
                                this.allDoorsDoubleModels.unshift(resources[i]);
                            } else {
                                this.allDoorsDoubleModels.push(resources[i]);
                            }
                            break;

                        case 'Door_Front':
                            if (pushFront) {
                                this.allDoorsFrontModels.unshift(resources[i]);
                            } else {
                                this.allDoorsFrontModels.push(resources[i]);
                            }
                            break;

                        case 'Cupboard_Door':
                            if (pushFront) {
                                this.allCupboardDoorModels.unshift(resources[i]);
                            } else {
                                this.allCupboardDoorModels.push(resources[i]);
                            }
                            break;

                        case 'Garage_Door':
                            if (pushFront) {
                                this.allGarageDoorModels.unshift(resources[i]);
                            } else {
                                this.allGarageDoorModels.push(resources[i]);
                            }
                            break;

                        case 'Window':
                            if (pushFront) {
                                this.allWindowModels.unshift(resources[i]);
                            } else {
                                this.allWindowModels.push(resources[i]);
                            }
                            break;

                        case 'Window_Double':
                            if (pushFront) {
                                this.allWindowDoubleModels.unshift(resources[i]);
                            } else {
                                this.allWindowDoubleModels.push(resources[i]);
                            }
                            break;

                        case 'French_Window':
                            if (pushFront) {
                                this.allFrenchWindowModels.unshift(resources[i]);
                            } else {
                                this.allFrenchWindowModels.push(resources[i]);
                            }
                            break;

                        case 'French_Window_Double':
                            if (pushFront) {
                                this.allFrenchWindowDoubleModels.unshift(resources[i]);
                            } else {
                                this.allFrenchWindowDoubleModels.push(resources[i]);
                            }
                            break;

                        case 'Picture_Window':
                            if (pushFront) {
                                this.allPictureWindowModels.unshift(resources[i]);
                            } else {
                                this.allPictureWindowModels.push(resources[i]);
                            }
                            break;

                        case 'Fixed_Window':
                            if (pushFront) {
                                this.allFixedWindowModels.unshift(resources[i]);
                            } else {
                                this.allFixedWindowModels.push(resources[i]);
                            }
                            break;

                        case 'Niche':
                            this.allNicheWindowModels.push(resources[i]);
                            break;

                        case 'Canopy':
                            if (pushFront) {
                                this.allCanopyModels.unshift(resources[i]);
                            } else {
                                this.allCanopyModels.push(resources[i]);
                            }
                            break;

                        case 'Velux':
                            if (pushFront) {
                                this.allVeluxModels.unshift(resources[i]);
                            } else {
                                this.allVeluxModels.push(resources[i]);
                            }
                            break;

                        case 'opening':
                            this.allOpeningModels.push(resources[i]);
                            break;
                    }
                }

                return this.allJoineryModels;
            }
        });

        // Load all technical elements models first
        getAssets(_ASSET_TYPE.TECHNICAL_ELEMENTS, this.OPTIMIZED_DB_FIELDS + '&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.medias.lk=vlp', (res: any) => {
            var resources = res.data.resources;

            if (resources !== undefined && resources !== null && resources.length > 0) {
                this.allTechElementsModels = resources;

                for (var i = 0; i < resources.length; i++) {
                    switch (resources[i].technicalElementType.name) {
                        case 'circularPole':
                        case 'rectangularPole':
                            this.allPoleModels.push(resources[i]);
                            break;

                        case 'stove':
                            this.allStoveModels.push(resources[i]);
                            break;

                        case 'fireplace':
                            this.allFireplaceModels.push(resources[i]);
                            break;

                        case 'radiator':
                            this.allRadiatorModels.push(resources[i]);
                            break;

                        case 'boiler':
                            this.allBoilerModels.push(resources[i]);
                            break;

                        case 'electrical outlet':
                            this.allSwitchBoardModels.push(resources[i]);
                            break;

                        case 'air-conditioner':
                            this.allAirConditionerModels.push(resources[i]);
                            break;

                        case 'wardRobe':
                            this.allWardRobeModels.push(resources[i]);
                            break;

                        case 'beam':
                            this.allBeamModels.push(resources[i]);
                            break;

                        case 'spotLight':
                            this.allSpotLightModels.push(resources[i]);
                            break;

                        case 'Rosette':
                            this.allRosetteModels.push(resources[i]);
                            break;

                        case 'Stair_guard_rail':
                            this.allStairModels.push(resources[i]);
                            break;

                        case 'circularStairs':
                            this.allCircularStairModels.push(resources[i]);
                            break;

                        case 'wallDecoration':
                            this.allWallDecorationModels.push(resources[i]);
                            break;

                        case 'socketTV':
                        case 'socketSixteen':
                            this.allSocketModels.push(resources[i]);
                            break;
                    }
                }

                this.allModelsForCurrentTechnicalElement = this.allTechElementsModels;
            }
        });
        (globalThis as any).__rhinov_TulipAssetConstant_instance = this;
    }

    getmodel() {
        return this.model;
    }
    
    getfunctionalities(): Functionality[] {
        return this.functionalities;
    }

    getupdatedJoineryList(entity: Joinery) {
        switch (entity.joineryType) {
            case SceneConstants.JoineryType.door:
                if ((entity as Door).nbDoors === 1) {
                    return this.allDoorsModels;
                }
                else {
                    return this.allDoorsDoubleModels;
                }

            case SceneConstants.JoineryType.frontDoor:
                return this.allDoorsFrontModels;

            case SceneConstants.JoineryType.window:
                if ((entity as Window).nbCasement === 1) {
                    return this.allWindowModels;
                }
                else {
                    return this.allWindowDoubleModels;
                }
            case SceneConstants.JoineryType.frenchWindow:
                if ((entity as FrenchDoor).nbDoors === 1) {
                    return this.allFrenchWindowModels;
                }
                else {
                    return this.allFrenchWindowDoubleModels;
                }

            case SceneConstants.JoineryType.pictureWindow:
                return this.allPictureWindowModels;

            case SceneConstants.JoineryType.fixedWindow:
                return this.allFixedWindowModels;

            case SceneConstants.JoineryType.niche:
                return this.allNicheWindowModels;

            case SceneConstants.JoineryType.velux:
                return this.allVeluxModels;

            case SceneConstants.JoineryType.canopy:
                return this.allCanopyModels;

            case SceneConstants.JoineryType.cupboardDoor:
                return this.allCupboardDoorModels;

            case SceneConstants.JoineryType.garageDoor:
                return this.allGarageDoorModels;

            case SceneConstants.JoineryType.opening:
                return this.allOpeningModels;

            default:
                return this.allJoineryModels;
        }
    }

    getupdatedTechnicalElementList(entity: TechnicalElement) {
        switch (entity.objectId) {
            case SceneConstants.TechnicalElementType.pole:
                return this.allPoleModels;

            case SceneConstants.TechnicalElementType.stove:
                return this.allStoveModels;

            case SceneConstants.TechnicalElementType.fireplace:
                return this.allFireplaceModels;

            case SceneConstants.TechnicalElementType.radiator:
                return this.allRadiatorModels;

            case SceneConstants.TechnicalElementType.boiler:
                return this.allBoilerModels;

            case SceneConstants.TechnicalElementType.switchBoard:
                return this.allSwitchBoardModels;

            case SceneConstants.TechnicalElementType.airConditioner:
                return this.allAirConditionerModels;

            case SceneConstants.TechnicalElementType.wardRobe:
                return this.allWardRobeModels;

            case SceneConstants.TechnicalElementType.spotLight:
                return this.allSpotLightModels;

            case SceneConstants.TechnicalElementType.rosette:
                return this.allRosetteModels;

            case SceneConstants.TechnicalElementType.beam:
                return this.allBeamModels;

            case SceneConstants.TechnicalElementType.wallDecoration:
                return this.allWallDecorationModels;
            case SceneConstants.TechnicalElementType.guardrail:
                return this.allModelsForCurrentDecoratedWall;

            case SceneConstants.TechnicalElementType.socketTV:
            case SceneConstants.TechnicalElementType.socketThirtyTwo:
            case SceneConstants.TechnicalElementType.socketSixteen:
                return this.allSocketModels;

            default:
                return this.allTechElementsModels;
        }
    }

    getModelList(entity: Entity) {
        switch (entity.entityType) {
            case SceneConstants.EntityType.Joinery:
               return this.getupdatedJoineryList(entity as Joinery);

            case SceneConstants.EntityType.TechnicalElement:
                return this.getupdatedTechnicalElementList(entity as TechnicalElement);

            case SceneConstants.EntityType.Staircase:
                return this.allStairModels;
            case SceneConstants.EntityType.Wall:
                return this.allModelsForCurrentDecoratedWall;
            case SceneConstants.EntityType.Room:
                return this.allModelsForCurrentCornice;        
        }
    }

    getdropDownDatas() {
        return this.dropDownDatas
    }

    static getinstance(): TulipAssetConstant {
        const g = globalThis as any;
        if (!g.__rhinov_TulipAssetConstant_instance) {
            new TulipAssetConstant();
        }
        return g.__rhinov_TulipAssetConstant_instance!;
    }
}

